import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { connect } from "react-redux";
import { useInput } from "react-hanger";
import { Helmet } from "react-helmet-async";
import styled from "styled-components";
import Alert from "@mui/material/Alert";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";

import imgBackground from "../../../assets/images/background.jpg";
import { alertActions, authActions } from "../../../redux/actions";
import { authServices } from "../../../services";

const Background = styled.div`
  min-width: 100vw;
  min-height: 100vh;
  background-image: url(${imgBackground});
  background-size: cover;
  filter: blur(5px);
  -webkit-filter: blur(5px);
`;

const Header = styled.div`
  margin: 0 10px;
  font-family: "Bolts SF Regular";
  font-size: 24px;
  color: #dc0100;
`;

const Form = styled.form`
  width: 350px;
  margin: 0 16px;
  padding: 20px;
  background: rgba(255, 255, 255, 0.6);
  border-radius: 4px;
  display: flex;
  flex-direction: column;
  row-gap: 12px;
`;

const LoginPage = (props) => {
  const username = useInput("");
  const password = useInput("");
  const otpToken = useInput("");
  const navigate = useNavigate();

  const isLoginDisabled = () => {
    return (
      !username.value
      || !password.value
      || !otpToken.value
    );
  }

  const onSubmit = (e) => {
    e.preventDefault();
    props.login(username.value, password.value, otpToken.value);
  }

  useEffect(() => {
    if (authServices.isLoggedIn())
      navigate("/orders");
  }, [props])

  useEffect(() => {
    props.alertReset();
  }, [])

  return (
    <>
      <Helmet>
        <title>Login</title>
      </Helmet>

      <Background />
      <Box
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          minWidth: "100vw",
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <Header>HONG BAO MEDIA</Header>
        <Form onSubmit={ onSubmit }>
          {
            props.alert.message &&
            <Alert variant="outlined" severity={ props.alert.type }>
              { props.alert.message }
            </Alert>
          }
          <TextField
            fullWidth
            variant="outlined"
            label="Username"
            value={ username.value }
            onChange={ username.onChange }
          />
          <TextField
            fullWidth
            variant="outlined"
            type="password"
            label="Password"
            value={ password.value }
            onChange={ password.onChange }
          />
          <TextField
            fullWidth
            variant="outlined"
            label="OTP Token"
            value={ otpToken.value }
            onChange={ otpToken.onChange }
          />
          <Button
            fullWidth
            variant="contained"
            type="submit"
            disabled={ isLoginDisabled() ? true : false }
          >
            Login
          </Button>
        </Form>
      </Box>
    </>
  );
}

const mapState = (state) => {
  const { isLoggingIn } = state.auth;
  return {
    isLoggingIn,
    alert: state.alert,
  };
}

const actionCreators = {
  alertReset: alertActions.reset,
  login: authActions.login,
};

export default connect(mapState, actionCreators)(LoginPage);
